<template>
  <div class="scroll-top-button">
    <a class="scroll-top-button__button" href="#" @click.prevent="handleScroll">
      {{ $t('ui.buttons.back_to_top') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'ScrollTopButton',

  props: {
    scrollable: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleScroll() {
      const scrollable = this.scrollable ? document.querySelector(`.${this.scrollable}`) : window
      scrollable.scroll({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped>
.scroll-top-button {
  display: inline-block;
  position: absolute;
  bottom: -40px;
  left: 0;
  right: 0;
  text-align: center;
}

.scroll-top-button__button {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  color: #fff;
  border-radius: 20px;
  padding: 6px 10px;
  background-color: var(--c-primary);
}
</style>
